module.exports = __webpack_public_path__ + "f8beac049b1dc836c5e432ab4d3f4180.woff2";